import { Stack } from 'expo-router';

import { BASE_STACK_SCREEN_OPTIONS } from '@/constants/screenOptions';
import { useColors } from '@/hooks/useColors';

/**
 * The stack a tab holding only its root renders inside. The hidden content library tab is the
 * one user; the visible tabs render `TabStack`, which holds the screens they open too.
 *
 * It exists for the header, not for navigation. A native header, and with it the large
 * title that collapses on scroll and the Liquid Glass bar, needs a stack to live in, and a
 * screen placed straight under the native tab bar has none.
 *
 * The status bar color repeats what the secure layout declares for the tab group, because the
 * innermost stack's screen is the one the native layer reads it from.
 */
export function TabRootStack() {
  const { colors, statusBarStyle } = useColors();

  return (
    <Stack
      screenOptions={{
        ...BASE_STACK_SCREEN_OPTIONS,
        statusBarBackgroundColor: colors.background[0],
        statusBarStyle,
      }}
    />
  );
}
